import storage from '@/utils/storage'

const userManager = {

  login (userInfo) {
    console.log(userInfo)
  },

  logout () {
  },

  /**
   * userId
   * @param userId
   */
  setUserId (userId) {
    storage.setItem('userId', userId)
  },

  getUserId () {
    return storage.getItem('userId')
  },

  clearUserId () {
    storage.removeItem('userId')
  },

  /**
   * token
   * @param token
   */
  setToken (token) {
    storage.setItem('token', token)
  },

  getToken () {
    return storage.getItem('token')
  },

  clearToken () {
    storage.removeItem('token')
  },


}

export default userManager
